import gsap from "gsap"
import CustomEase from "gsap/CustomEase"
import Lenis from "lenis"

gsap.registerPlugin(CustomEase)

export default class Pilot {
    constructor(options = {}) {
        this.buttons = options.buttons || document.querySelectorAll(".open-pilot")
        this.lightboxLenis = null
        this.scroll = options.scroll
        this.sidebarTl = null
        this.isSidebarOpen = false
        this.data = window.pilotData || null
        
        this.init()
    }

    isMobile() {
        return window.innerWidth <= 1024 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    }

    init() {
        if (!this.buttons || this.buttons.length === 0) return
        
        this.buttons.forEach(button => {
            button.addEventListener("click", (e) => {
                e.preventDefault()
                this.openLightbox()
            })
        })
    }

    openLightbox() {
        if (!this.data) {
            console.error('Pilot data not found')
            return
        }
        
        this.createLightboxElement()
        this.animateLightboxOpen()
        this.renderContent(this.data)
        this.initLightboxScroll()
        this.attachCloseHandlers()
    }

    createLightboxElement() {
        const lightbox = document.createElement("div")
        lightbox.className = "lightbox"
        lightbox.innerHTML = `
            <div class="lightbox__overlay"></div>
            <div class="lightbox__content">
                <div class="lightbox__loader">
                    
                </div>
            </div>
        `
        document.body.appendChild(lightbox)
        
        if (this.isMobile()) {
            // Mobile: Lock body scroll - save scroll position
            this.scrollPosition = window.pageYOffset
            document.body.style.position = 'fixed'
            document.body.style.top = `-${this.scrollPosition}px`
            document.body.style.width = '100%'
        } else {
            // Desktop: Use Lenis stop
            document.body.style.overflow = "hidden"
            if (this.scroll) {
                this.scroll.stop()
            }
        }
    }

    animateLightboxOpen() {
        gsap.fromTo(".lightbox__overlay", 
            { 
                scaleY: 0,
                transformOrigin: "bottom"
            },
            { 
                scaleY: 1,
                duration: 0.8,
                ease: "power3.out"
            }
        )
        
        gsap.fromTo(".lightbox__content",
            {
                y: "100%",
                opacity: 0
            },
            {
                y: 0,
                opacity: 1,
                duration: 0.8,
                ease: "power3.out",
                delay: 0.2
            }
        )
    }

    renderContent(data) {
        const lightboxContent = document.querySelector(".lightbox__content")
        const baseUrl = window.pilotBaseUrl || ''
        
        lightboxContent.innerHTML = `
            <div class="lightbox__header">
                <div class="lightbox__header__navigation">
                    <div class="lightbox__header__navigation__trigger">
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <line y1="7.17065" x2="13.4267" y2="7.17065" stroke="white" stroke-width="1.5"/>
                            <line x1="6.6709" y1="13.9268" x2="6.6709" y2="0.500071" stroke="white" stroke-width="1.5"/>
                        </svg>
                        <span>Documentation</span>
                    </div>
                    <div class="lightbox__header__navigation__sidebar">
                        <ul class="lightbox__sidebar__content__external">
                            ${data.external_links.map(item => `
                                <li><a href="${item.url}" target="${item.target}">${item.title} <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="1.86133" y1="3.49878" x2="7.86133" y2="3.49878" stroke="white" stroke-width="1.25"/>
                                    <line x1="2.35933" y1="8.34541" x2="6.60197" y2="4.10277" stroke="white" stroke-width="1.25"/>
                                    <line x1="7.23633" y1="8.87573" x2="7.23633" y2="2.87573" stroke="white" stroke-width="1.25"/>
                                </svg></a></li>
                            `).join('')}
                        </ul>

                        <div class="lightbox__sidebar__content__actions">
                            <p>${data.contact.phone} <br /> ${data.contact.email}</p>

                            <a href="${data.contact.whatsapp}" target="_blank" aria-label="Open whatsapp" class="button">
                                <span data-button-animate-chars="" class="button__text">Whatsapp</span>
                                <div class="button__arrow">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.3799 0.5C5.13817 0.5 0.879883 4.75829 0.879883 10C0.879883 11.6848 1.34195 13.2572 2.11256 14.6298L0.895211 18.9756C0.875762 19.0452 0.874884 19.1186 0.892662 19.1886C0.91044 19.2586 0.946255 19.3227 0.996534 19.3745C1.04681 19.4263 1.1098 19.4641 1.17922 19.484C1.24863 19.5039 1.32205 19.5052 1.39215 19.4879L5.92353 18.3649C7.25506 19.0758 8.76595 19.5 10.3799 19.5C15.6216 19.5 19.8799 15.2417 19.8799 10C19.8799 4.75829 15.6216 0.5 10.3799 0.5ZM10.3799 1.32609C15.1751 1.32609 19.0538 5.20476 19.0538 10C19.0538 14.7952 15.1751 18.6739 10.3799 18.6739C8.84255 18.6739 7.40272 18.2731 6.15103 17.5727C6.05948 17.5216 5.95191 17.5072 5.85012 17.5324L1.88184 18.5158L2.94591 14.7193C2.96113 14.6657 2.96534 14.6095 2.95827 14.5542C2.95119 14.4989 2.933 14.4456 2.90476 14.3975C2.14408 13.1076 1.70597 11.6068 1.70597 10C1.70597 5.20476 5.58464 1.32609 10.3799 1.32609ZM6.9279 5.04348C6.66313 5.04348 6.28499 5.14198 5.97435 5.47669C5.78778 5.67773 5.01032 6.43523 5.01032 7.76698C5.01032 9.15544 5.97328 10.3535 6.08972 10.5074H6.09052V10.5082C6.07948 10.4937 6.23831 10.7237 6.45032 10.9995C6.66234 11.2753 6.95881 11.6376 7.33127 12.0297C8.07618 12.814 9.12352 13.7205 10.4234 14.2748C11.0221 14.5298 11.4943 14.6837 11.8522 14.796C12.5153 15.0042 13.1192 14.9725 13.5729 14.9057C13.9125 14.8557 14.286 14.6926 14.6555 14.4588C15.0251 14.2249 15.3872 13.9341 15.547 13.4923C15.6614 13.1756 15.7195 12.8829 15.7406 12.642C15.7511 12.5216 15.7524 12.4153 15.7446 12.3169C15.7368 12.2185 15.7451 12.1431 15.6534 11.9926C15.4611 11.6769 15.2434 11.6686 15.0161 11.5562C14.8899 11.4937 14.5304 11.3182 14.1699 11.1464C13.8097 10.9747 13.4979 10.8228 13.3059 10.7543C13.1845 10.7106 13.0364 10.6478 12.8226 10.672C12.6089 10.6962 12.3978 10.8504 12.2749 11.0326C12.1584 11.2053 11.6894 11.7589 11.5464 11.9216C11.5445 11.9205 11.5569 11.9262 11.5004 11.8982C11.3236 11.8107 11.1073 11.7363 10.7873 11.5675C10.4672 11.3986 10.0669 11.1493 9.62882 10.7632V10.7624C8.97679 10.1883 8.52006 9.46763 8.37598 9.22554C8.38568 9.21399 8.37482 9.22798 8.39534 9.2078L8.39614 9.20699C8.5434 9.06195 8.67391 8.88872 8.78418 8.76168C8.94053 8.58155 9.00953 8.42277 9.08428 8.27441C9.23326 7.97875 9.15031 7.65339 9.06411 7.48221V7.4814C9.07007 7.49324 9.01749 7.37724 8.96085 7.24342C8.90405 7.10922 8.83166 6.93523 8.75433 6.7497C8.59968 6.37864 8.42702 5.96246 8.32435 5.71871V5.7179C8.20339 5.43078 8.03974 5.22394 7.82579 5.12415C7.61184 5.02436 7.42281 5.05273 7.41517 5.05235H7.41436C7.26168 5.04531 7.09414 5.04348 6.9279 5.04348ZM6.9279 5.86957C7.08715 5.86957 7.24415 5.87151 7.37564 5.87763C7.51091 5.88437 7.50249 5.88493 7.47648 5.87279C7.45005 5.86047 7.48591 5.85646 7.5628 6.03898C7.66334 6.27766 7.83684 6.69534 7.99198 7.06755C8.06954 7.25366 8.14213 7.42832 8.20011 7.5653C8.25809 7.70229 8.2895 7.77877 8.32596 7.85169V7.8525L8.32677 7.8533C8.36251 7.92383 8.35935 7.87868 8.34693 7.90332C8.25977 8.07631 8.24794 8.11879 8.15977 8.22036C8.02553 8.37502 7.88859 8.54749 7.81611 8.61889C7.75269 8.68118 7.63827 8.77823 7.56683 8.9682C7.49528 9.15846 7.52867 9.4195 7.64347 9.61438C7.79631 9.87386 8.29996 10.6936 9.08267 11.3827C9.57559 11.8173 10.0348 12.1048 10.4017 12.2984C10.7685 12.4919 11.0673 12.6049 11.1342 12.638C11.2929 12.7166 11.4665 12.7776 11.6682 12.7534C11.87 12.7291 12.0439 12.6067 12.1547 12.4815L12.1555 12.4807C12.3029 12.3136 12.7408 11.8136 12.9509 11.5053C12.9598 11.5085 12.9569 11.5061 13.0267 11.5312V11.532H13.0276C13.0594 11.5433 13.4588 11.7221 13.8149 11.8918C14.171 12.0615 14.5324 12.2378 14.6499 12.2959C14.8194 12.3798 14.8995 12.4344 14.9201 12.4347C14.9215 12.471 14.9229 12.5104 14.9177 12.5702C14.9032 12.7361 14.8589 12.9657 14.7701 13.2116C14.7266 13.3319 14.5 13.5801 14.2142 13.761C13.9285 13.9418 13.5807 14.0695 13.4519 14.0885C13.0646 14.1455 12.6048 14.1664 12.0998 14.0078C11.7497 13.8979 11.3131 13.7556 10.7477 13.5149C9.60122 13.0259 8.62676 12.1939 7.93066 11.461C7.58262 11.0945 7.30377 10.7534 7.10538 10.4953C6.90737 10.2377 6.82091 10.1037 6.74881 10.0089L6.748 10.0081C6.62003 9.83883 5.8364 8.74883 5.8364 7.76698C5.8364 6.72786 6.31904 6.32038 6.58021 6.03898C6.71731 5.89125 6.8672 5.86957 6.9279 5.86957Z" fill="currentColor"/>
                                    </svg>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <button class="lightbox__close">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line x1="2" y1="2" x2="22" y2="22" stroke="currentColor" stroke-width="2"/>
                        <line x1="22" y1="2" x2="2" y2="22" stroke="currentColor" stroke-width="2"/>
                    </svg>
                </button>
            </div>
            <div class="lightbox__inner">
                <h2 class="title title--dark">${data.title}</h2>
                <div class="lightbox__body" data-split="heading">
                    ${data.body.map(item => item.replace(/src="images\//g, `src="${baseUrl}/public/images/`)).join('')}
                </div>
            </div>
            <div class="lightbox__sidebar">
                <img src="${baseUrl}/public/${data.image}" alt="${data.title}" />

                <div class="lightbox__sidebar__content">
                    <div>
                        <h5>Map</h5>
                        <div class="map-wrapper">
                            <div class="map-wrapper__image">
                                <img src="${baseUrl}/public/${data.map.image}" alt="Map" />
                            </div>

                            <div class="map-wrapper__content">
                                ${data.map.infos.map(item => `
                                    <p>
                                        <span>${item.attribute}:</span>
                                        ${item.value}
                                    </p>
                                `).join('')}
                            </div>
                        </div>
                    </div>

                    <div>
                        <ul class="lightbox__sidebar__content__external">
                            ${data.external_links.map(item => `
                                <li><a href="${item.url}" target="${item.target}">${item.title} <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="1.86133" y1="3.49878" x2="7.86133" y2="3.49878" stroke="white" stroke-width="1.25"/>
                                    <line x1="2.35933" y1="8.34541" x2="6.60197" y2="4.10277" stroke="white" stroke-width="1.25"/>
                                    <line x1="7.23633" y1="8.87573" x2="7.23633" y2="2.87573" stroke="white" stroke-width="1.25"/>
                                </svg></a></li>
                            `).join('')}
                        </ul>

                        <div class="lightbox__sidebar__content__actions">
                            <p>
                                <a href="tel:+34695386666" target="_blank">${data.contact.phone}</a> <br />
                                <a href="mailto:opsmanager@fincalacaminera.com" target="_blank">${data.contact.email}</a>
                            </p>

                            <a href="${data.contact.whatsapp}" target="_blank" aria-label="Open whatsapp" class="button button--icon">
                                <div class="button__bg"></div>
                                <span data-button-animate-chars="" class="button__text">Whatsapp</span>
                                <div class="button__arrow">
                                    <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <line x1="1.41021" y1="1.40033" x2="6.92439" y2="6.91451" stroke="currentColor" stroke-width="1.5"/>
                                        <line x1="0.835393" y1="11.9423" x2="6.34957" y2="6.42815" stroke="currentColor" stroke-width="1.5"/>
                                    </svg>
                                </div>
                            </a>
                        </div>
                    </div>      
                </div>
            </div>
        `
        
        gsap.from(".lightbox__inner, .lightbox__sidebar", {
            y: 30,
            opacity: 0,
            duration: 0.5,
            stagger: 0.2,
            ease: "power2.out"
        })
        
        this.setupSidebarAnimation()
        this.attachSidebarHandlers()
    }

    setupSidebarAnimation() {
        const sidebar = document.querySelector('.lightbox__header__navigation__sidebar')
        if (!sidebar) return

        this.sidebarTl = gsap.timeline({ paused: true })
        
        // Set initial hidden state
        gsap.set(sidebar, { display: 'none', scaleY: 0, transformOrigin: "top" })
        gsap.set('.lightbox__header__navigation__sidebar .lightbox__sidebar__content__external li', { y: 20, autoAlpha: 0 })
        gsap.set('.lightbox__header__navigation__sidebar .lightbox__sidebar__content__actions', { y: 20, autoAlpha: 0 })
        
        // Build the animation timeline
        this.sidebarTl.set(sidebar, { display: 'block' })
        
        this.sidebarTl.to(sidebar, {
            duration: .8,
            scaleY: 1,
            ease: CustomEase.create("out", "0.125, 0.425, 0.270, 1.000")
        })
        
        this.sidebarTl.to('.lightbox__header__navigation__sidebar .lightbox__sidebar__content__external li', {
            duration: 0.5,
            y: 0,
            autoAlpha: 1,
            stagger: 0.05,
            ease: CustomEase.create("out", "0.125, 0.425, 0.270, 1.000")
        }, '-=0.5')
        
        this.sidebarTl.to('.lightbox__header__navigation__sidebar .lightbox__sidebar__content__actions', {
            duration: 0.4,
            y: 0,
            autoAlpha: 1,
            ease: CustomEase.create("out", "0.125, 0.425, 0.270, 1.000")
        }, '-=0.4')
    }

    attachSidebarHandlers() {
        const trigger = document.querySelector('.lightbox__header__navigation__trigger')
        if (!trigger) return
        
        trigger.addEventListener('click', (e) => {
            e.preventDefault()
            this.toggleSidebar()
        })
    }

    toggleSidebar() {
        if (this.isSidebarOpen) {
            this.closeSidebar()
        } else {
            this.openSidebar()
        }
    }

    openSidebar() {
        const trigger = document.querySelector('.lightbox__header__navigation__trigger')
        this.isSidebarOpen = true
        if (trigger) trigger.classList.add('is-active')
        if (this.sidebarTl) this.sidebarTl.play()
    }

    closeSidebar() {
        const trigger = document.querySelector('.lightbox__header__navigation__trigger')
        const sidebar = document.querySelector('.lightbox__header__navigation__sidebar')
        
        this.isSidebarOpen = false
        if (trigger) trigger.classList.remove('is-active')
        
        gsap.to(sidebar, {
            duration: 0.3,
            ease: 'power2.in',
            autoAlpha: 0,
            onComplete: () => {
                if (this.sidebarTl) this.sidebarTl.pause(0)
                gsap.set(sidebar, { display: 'none', autoAlpha: 1 })
            }
        })
    }

    initLightboxScroll() {
        const lightboxInner = document.querySelector(".lightbox__inner")
        this.lightboxLenis = new Lenis({
            wrapper: lightboxInner,
            content: lightboxInner,
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            orientation: "vertical",
            gestureOrientation: "vertical",
            smoothWheel: true,
            wheelMultiplier: 1,
            smoothTouch: false,
            touchMultiplier: 2,
            infinite: false,
        })
        
        const rafLightbox = (time) => {
            if (this.lightboxLenis) {
                this.lightboxLenis.raf(time)
                requestAnimationFrame(rafLightbox)
            }
        }
        requestAnimationFrame(rafLightbox)
    }

    attachCloseHandlers() {
        const closeButton = document.querySelector(".lightbox__close")
        const overlay = document.querySelector(".lightbox__overlay")
        
        if (closeButton) {
            closeButton.addEventListener("click", () => this.closeLightbox())
        }
        
        if (overlay) {
            overlay.addEventListener("click", () => this.closeLightbox())
        }
    }

    closeLightbox() {
        if (this.lightboxLenis) {
            this.lightboxLenis.destroy()
            this.lightboxLenis = null
        }
        
        gsap.to(".lightbox__overlay", {
            scaleY: 0,
            transformOrigin: "bottom",
            duration: 0.6,
            ease: "power3.in"
        })
        
        gsap.to(".lightbox__content", {
            y: "100%",
            opacity: 0,
            duration: 0.6,
            ease: "power3.in",
            onComplete: () => {
                document.querySelector(".lightbox")?.remove()
                
                if (this.isMobile()) {
                    // Mobile: Unlock body scroll - restore scroll position
                    document.body.style.position = ''
                    document.body.style.top = ''
                    document.body.style.width = ''
                    window.scrollTo(0, this.scrollPosition)
                } else {
                    // Desktop: Restore Lenis
                    document.body.style.overflow = ""
                    if (this.scroll) {
                        this.scroll.start()
                    }
                }
            }
        })
    }
}
